const routes = [
    {
        path: '/minor/application',
        component: () => import('../pages/application/Index'),
        meta: {
            isAuthenticated: true,
            isStudent: true,
            permission: 'minorapplication_studentform'
        }
    },
    {
        path: '/minor/application/admin',
        component: () => import('../pages/admin/Index'),
        meta: {
            isAuthenticated: true,
            permission: 'minorapplication_adminindex'
        }
    }
];

export default routes;
